import { InsuranceProviderConfiguration, InsuranceProviderConfigurationData } from './insurance-provider-configuration.model'

export const defaultConfiguration: InsuranceProviderConfigurationData = {
  id: '',
  payerId: '',
  type: InsuranceProviderConfiguration.TYPE.SERVICE_REVIEWS,
  subtypeId: InsuranceProviderConfiguration.SUBTYPE_ID.HEALTH_SERVICES,
  source: InsuranceProviderConfiguration.SOURCE.AVAILITY,
  elements: {
    requestingProvider: {
      type: InsuranceProviderConfiguration.ElementType.OBJECT,
      order: 1,
      elements: {
        lastName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        npi: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        contactName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        phone: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
      },
      allowed: true,
    },
    subscriber: {
      type: InsuranceProviderConfiguration.ElementType.OBJECT,
      order: 1,
      elements: {
        lastName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        firstName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        suffix: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        memberId: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
      },
      allowed: true,
    },
    patient: {
      type: InsuranceProviderConfiguration.ElementType.OBJECT,
      order: 3,
      elements: {
        lastName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        firstName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        middleName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        suffix: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        birthDate: {
          type: InsuranceProviderConfiguration.ElementType.DATE,
          order: 0,
          allowed: true,
        },
        genderCode: {
          type: InsuranceProviderConfiguration.ElementType.ENUMERATION,
          order: 0,
          allowed: true,
          values: [
            {
              code: 'F',
              value: 'Female',
            },
            {
              code: 'M',
              value: 'Male',
            },
            {
              code: 'U',
              value: 'Unknown',
            },
          ],
        },
      },
      allowed: true,
    },
    diagnoses: {
      type: InsuranceProviderConfiguration.ElementType.OBJECT_ARRAY,
      order: 0,
      elements: {
        qualifierCode: {
          type: InsuranceProviderConfiguration.ElementType.ENUMERATION,
          order: 0,
          allowed: true,
          required: false,
          values: [
            {
              code: 'BF',
              value: 'International Classification of Diseases Clinical Modification (ICD-9-CM) Diagnosis',
            },
            {
              code: 'ABF',
              value: 'International Classification of Diseases Clinical Modification (ICD-10-CM) Diagnosis',
            },
            {
              code: 'ABK',
              value: 'International Classification of Diseases Clinical Modification (ICD-10-CM) Principal Diagnosis',
            },
          ],
        },
        code: {
          type: InsuranceProviderConfiguration.ElementType.COLLECTION,
          order: 0,
          allowed: true,
          required: false,
        },
      },
      allowed: true,
    },
    renderingProviders: {
      type: InsuranceProviderConfiguration.ElementType.OBJECT_ARRAY,
      order: 33,
      elements: {
        roleCode: {
          type: InsuranceProviderConfiguration.ElementType.ENUMERATION,
          order: 0,
          allowed: true,
          values: [
            {
              code: 'AAJ',
              value: 'Admitting Services',
            },
            {
              code: 'DD',
              value: 'Assistant Surgeon',
            },
            {
              code: '71',
              value: 'Attending Physician',
            },
            {
              code: 'G3',
              value: 'Clinic',
            },
            {
              code: 'FA',
              value: 'Facility',
            },
            {
              code: 'QV',
              value: 'Group Practice',
            },
            {
              code: '72',
              value: 'Operating Physician',
            },
            {
              code: 'DK',
              value: 'Ordering Physician',
            },
            {
              code: '73',
              value: 'Other Physician',
            },
            {
              code: 'P3',
              value: 'Primary Care Provider',
            },
            {
              code: 'QB',
              value: 'Purchase Service Provider',
            },
            {
              code: 'DN',
              value: 'Referring Provider',
            },
            {
              code: '77',
              value: 'Service Location',
            },
            {
              code: 'SJ',
              value: 'Service Provider',
            },
          ],
        },
        lastName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        firstName: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        npi: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        taxId: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
        phone: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 0,
          allowed: true,
        },
      },
      allowed: true,
    },
    procedures: {
      type: InsuranceProviderConfiguration.ElementType.OBJECT_ARRAY,
      order: 33,
      elements: {
        code: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 1,
          allowed: true,
        },
        modifierCode1: {
          type: InsuranceProviderConfiguration.ElementType.TEXT,
          order: 1,
          allowed: true,
        },
      },
      allowed: true,
    },
  },
  createdAt: '2024-07-09T15:06:06.280Z',
  updatedAt: '2024-07-09T15:06:06.296Z',
}
